// extracted by mini-css-extract-plugin
module.exports = {"imageAvatarContainer":"TFBImageAvatar_imageAvatarContainer__3Ofxn","imageAvater":"TFBImageAvatar_imageAvater__tOMkU"};